export const csvA : string =  `canvas/Canevas_2_A.csv`;
export const csvB : string = `canvas/Canevas_2_B.csv`;
export const csvC : string = `canvas/Canevas_2_C.csv`;
export const csvS : string = `canvas/Canevas_2_S.csv`;
export const csvK : string = `canvas/Canevas_2_K.csv`;